import { DirektBanner } from '@/components/DirektBanner';
import { LabradorComponent } from '@/types/component';

export const LabradorDirektBanner: LabradorComponent = () => {
  return <DirektBanner />;
};
